import {
  BASE_DIALOG_DEFAULT_CONFIG,
  BaseDialog,
  BaseDialogDefinition,
  BaseDialogIngredients,
  MEDIUM_DIALOG_CONFIG,
} from '@aviary/dialogs/base-dialog/base-dialog.types';
import {MatDialogConfig} from '@angular/material/dialog';
import {ExtendedFormGroup} from '@aviary/forms/extensions/extended-form-group/extended-form-group';

export const FORM_DIALOG_DEFAULT_CANCEL_BUTTON_LABEL: string = 'Cancel';
export const FORM_DIALOG_DEFAULT_CONFIRM_BUTTON_LABEL: string = 'Save';

export interface FormDialog<DataType, ValueType> extends BaseDialog<DataType, ValueType> {
  readonly dialogDefinition: FormDialogDefinition<ValueType>;
}

export interface FormDialogDefinition<ValueType> extends BaseDialogDefinition<ValueType> {
  readonly formGroup: ExtendedFormGroup;
  readonly allowConfirmWhenPristine?: boolean;
}

export const FORM_DIALOG_DEFAULT_CONFIG: MatDialogConfig = {
  ...BASE_DIALOG_DEFAULT_CONFIG,
  ...MEDIUM_DIALOG_CONFIG,
  disableClose: true
};

/** WHY "SUPERTYPES"? See documentation on openDialog() in MxDialogService. */
export type FormDialogIngredients<
  DataSupertype, DataType extends DataSupertype,
  ValueSupertype, ValueType extends ValueSupertype,
  DialogComponent extends FormDialog<DataSupertype, ValueSupertype>
> = BaseDialogIngredients<DataType, ValueType, DialogComponent>;
